export type AgeType = 'adult' | 'minor' | 'baby';
export type Gender = 'Non-Binary' | 'Female' | 'Male' | 'Other' | 'Trans Man' | 'Trans Woman';
export type Region = 'Australia' | 'United States';

export const getRequiredFields = (gender: Gender, ageType: AgeType, region: Region): string[] => {
  if (ageType === 'baby') {
    let required = ['length', 'kidsClothing', 'kid_shoe_size'];
    if (region === 'Australia') {
      required.push('weight');
    }
    return required;
  }

  const common = ['height', 'shoe'];

  const regionRequired: Record<Region, Record<'adult' | 'minor', Record<Gender, string[]>>> = {
    'United States': {
      adult: {
        Male: ['weight'],
        'Trans Man': ['weight'],
        Female: ['weight'],
        'Trans Woman': ['weight'],
        ['Non-Binary']: ['weight'],
        Other: ['weight'],
      },
      minor: {
        Male: ['weight'],
        Female: ['weight'],
        ['Non-Binary']: [],
        Other: [],
        'Trans Man': [],
        'Trans Woman': [],
      },
    },
    Australia: {
      adult: {
        Male: ['chest_size', 'waist', 'suit_size'],
        'Trans Man': ['chest_size', 'waist', 'suit_size'],
        Female: ['bust_size', 'cup_size', 'waist', 'hip_size', 'dress_size'],
        'Trans Woman': ['bust_size', 'cup_size', 'waist', 'hip_size', 'dress_size'],
        ['Non-Binary']: ['chest_size', 'bust_size', 'cup_size', 'waist', 'hip_size', 'dress_size', 'suit_size'],
        Other: ['chest_size', 'bust_size', 'cup_size', 'waist', 'hip_size', 'dress_size', 'suit_size'],
      },
      minor: {
        Male: ['chest_size', 'waist', 'kidsClothing'],
        Female: ['bust_size', 'waist', 'kidsClothing'],
        ['Non-Binary']: [],
        Other: [],
        'Trans Man': [],
        'Trans Woman': [],
      },
    },
  };

  let required = [...common];

  const regionFields = regionRequired[region][ageType][gender] || [];
  required.push(...regionFields);

  return required;
};
